import { mainAxios } from "@/mainAxios.js";
import { getDefaultHeaders, getErrorMessage } from "../mainService";

export const getPlantillaById = async (id) => {
    try{
        const response = await mainAxios.get(
            `v1/plantillas-eci/${id}`,
            getDefaultHeaders()
        );
        //console.log("getPlantillaById response", response);
        return response.data.data;
    }catch (error) {
        throw new Error(getErrorMessage(error));
    }
}

export const getPlantillaByDepartamento = async (departamento) => {
    try {
        const response = await mainAxios.get(
            `v1/plantillas-eci/departamento/${departamento}`,
            getDefaultHeaders()
        );
        return response.data;
    } catch (error) {
        throw new Error(getErrorMessage(error));
    }
}